// Optional `written` / `writtenList` on the buffer record which columns this stamp claimed,
// so overlapping features can be combined without treating an unchanged sample as a miss.
export function writeHeight(heights, index, value) {
    heights[index] = value;
    const written = heights.written;
    if (written !== undefined && written[index] === 0) {
        written[index] = 1;
        heights.writtenList.push(index);
    }
}

export function ellipseWeight(u, v, noise, seed) {
    const warpU = noise.noise2(u * 2.2 + seed * 0.013, v * 2.2) * 0.16;
    const warpV = noise.noise2(u * 2.2, v * 2.2 + 4.2 + seed * 0.013) * 0.16;
    const radius = Math.hypot(u + warpU, v + warpV);
    const t = (1.04 - radius) / 0.24;
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    return t * t * (3 - 2 * t);
}

export function visit(feature, resolution, layoutSize, fn) {
    const stride = layoutSize / resolution;
    const reach = Math.hypot(feature.sx, feature.sz) * 1.25;
    const cos = Math.cos(feature.rotation);
    const sin = Math.sin(feature.rotation);
    const sx = Math.max(1, feature.sx);
    const sz = Math.max(1, feature.sz);

    let i0 = Math.floor((feature.x - reach) / stride);
    let i1 = Math.ceil((feature.x + reach) / stride);
    let j0 = Math.floor((feature.z - reach) / stride);
    let j1 = Math.ceil((feature.z + reach) / stride);
    if (i0 < 0) i0 = 0;
    if (j0 < 0) j0 = 0;
    if (i1 > resolution - 1) i1 = resolution - 1;
    if (j1 > resolution - 1) j1 = resolution - 1;

    for (let j = j0; j <= j1; j++) {
        const z = (j + 0.5) * stride;
        const row = j * resolution;
        for (let i = i0; i <= i1; i++) {
            const x = (i + 0.5) * stride;
            const dx = x - feature.x;
            const dz = z - feature.z;
            const u = (dx * cos + dz * sin) / sx;
            const v = (-dx * sin + dz * cos) / sz;
            fn(row + i, u, v);
        }
    }
}
